import React from 'react';
import { View, TouchableOpacity, Image, StyleSheet } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';

import styles from './PaymentCard.Styles';

function PaymentCard({
  icon,
  lastFourDigits,
  expiry,
  onPress,
  cardName,
  isDefault,
  isSelected,
  brand,
  customCardStyle,
  testID,
}) {
  const theme = useTheme();
  return (
    <View style={[styles.container(isDefault, isSelected, theme), customCardStyle]}>
      <TouchableOpacity
        style={[StyleSheet.absoluteFillObject, styles.card(isDefault)]}
        onPress={onPress}
        disabled={isDefault}
        testID={isDefault ? FrameworkTestKeys.TPDefaultPaymentCard : testID}
      >
        <Image source={icon} style={styles.iconImage(isDefault)} resizeMode="cover" />
        <View>
          <VFText style={styles.cardName(isSelected, theme)} i18nKey={cardName} />
          <VFText
            style={styles.cardNumber(theme)}
            i18nKey={
              isDefault ? '**** **** **** %1$s' : 'top_up_quick_action_payment_method_subtitle'
            }
            placeHolders={isDefault ? [lastFourDigits] : [brand, lastFourDigits]}
          />
        </View>
        {isDefault && (
          <VFText
            style={styles.expiryText(theme)}
            i18nKey="payment_method_expiry"
            placeHolders={[expiry]}
          />
        )}
      </TouchableOpacity>
    </View>
  );
}

PaymentCard.defaultProps = {
  isDefault: false,
};

PaymentCard.propTypes = {
  icon: PropTypes.any,
  lastFourDigits: PropTypes.string,
  expiry: PropTypes.string,
  onPress: PropTypes.func,
  isDefault: PropTypes.bool,
  isSelected: PropTypes.bool,
  cardName: PropTypes.string,
  brand: PropTypes.string,
  customCardStyle: ViewPropTypes.style,
  testID: PropTypes.string,
};

export default PaymentCard;
